/**
 * Response from the Favourites server
 */
export interface FavouriteResponse {
  /**
   * The unique id to identify the Favourites record
   */
  itemId: string;
  /**
   * Represents updated timestamp of the favourites record
   */
  ut: number;
}

/**
 * Count of all Favourites from Favourites server
 */
export interface FavouriteCount {
  count: number;
}

/**
 * Sort order attributes that could be used while working with favourites
 */
export enum SortOrder {
  /**
   * Represents ascending sort order.
   */
  ASC,
  /**
   * Represents descending sort order.
   */
  DESC,
}

/**
 * Sort by attributes that could be used while working with favourites
 */
export enum SortBy {
  /**
   * Represents sort by updated timestamp of the favourites record
   */
  TIMESTAMP = 'ut',
}
